// src/lib/seo.js
export const ORIGIN = 'https://solarya.hu';

export function canon(pathname = '/') {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${ORIGIN}${path}`;
}

/**
 * Kategória-lista canonical:
 * - ha van ?all=… vagy ?functions=… paraméter, akkor mindig a "tiszta" /kategoriak legyen a canonical
 * - egyébként a tényleges path
 */
export function categoryCanonical(pathname, searchParams) {
  const hasParams = !!(searchParams.get('all') || searchParams.get('functions'));
  return hasParams ? `${ORIGIN}/kategoriak` : canon(pathname);
}
